import { type LayoutProps as LayoutPropsV4 } from 'antd';
import { type SiderProps as SiderPropsV4 } from 'antd/lib/layout/Sider';
import { type LayoutProps as LayoutPropsV5, type SiderProps as SiderPropsV5 } from 'antd5';

import { type Version4Props, type Version5Props } from '../types';

import { StyledLayoutV4 as LayoutV4, StyledLayoutV5 as LayoutV5 } from './Layout.style';

interface PropsV5 extends Version5Props, LayoutPropsV5 {}
interface PropsV4 extends Version4Props, LayoutPropsV4 {}
type Props = PropsV5 | PropsV4;

interface SiderV5Props extends Version5Props, SiderPropsV5 {}
interface SiderV4Props extends Version4Props, SiderPropsV4 {}
type SiderProps = SiderV5Props | SiderV4Props;

export function Layout({ _version = 5, ...props }: Props) {
  if (_version === 4) {
    return <LayoutV4 {...props} />;
  }
  return <LayoutV5 {...props} />;
}

export function Header({ _version = 5, ...props }: Props) {
  if (_version === 4) {
    return <LayoutV4.Header {...props} />;
  }
  return <LayoutV5.Header {...props} />;
}

export function Footer({ _version = 5, ...props }: Props) {
  if (_version === 4) {
    return <LayoutV4.Footer {...props} />;
  }
  return <LayoutV5.Footer {...props} />;
}

export function Content({ _version = 5, ...props }: Props) {
  if (_version === 4) {
    return <LayoutV4.Content {...props} />;
  }
  return <LayoutV5.Content {...props} />;
}

export function Sider({ _version = 5, ...props }: SiderProps) {
  if (_version === 4) {
    return <LayoutV4.Sider {...props} />;
  }
  return <LayoutV5.Sider {...props} />;
}

// components added to Layout to reflect how antd behaves
Layout.Header = Header;
Layout.Footer = Footer;
Layout.Content = Content;
Layout.Sider = Sider;
